module.exports = __webpack_public_path__ + "img/taili5.b124b541.jpg";